import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//   import { useNavigate } from "react-router-dom";
//   import withReactContent from "sweetalert2-react-content";
//   import Swal from "sweetalert2";
//   import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
//   import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
//   import { useCheckUserPermission } from "../../common/userPermission";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";

//   const customerDelete = "customerDelete";

const BusinessTransaction = () => {
  const user_data = useSelector((state) => state.user_data);
  // const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [loading, setLoading] = useState(false);
  // const MySwal = withReactContent(Swal);

  // const showConfirmationAlert = (id) => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       showLoadingAlert(); // Show loader while deleting
  //       handleDelete(id);
  //     }
  //   });
  // };

  // const showLoadingAlert = () => {
  //   MySwal.fire({
  //     title: "Deleting...",
  //     text: "Please wait while we process your request.",
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       MySwal.showLoading(); // Show loading spinner
  //     },
  //   });
  // };

  // const handleDelete = async (id) => {
  //   let reqobj = {
  //     ID: id,
  //     Module: "customer",
  //   };

  //   try {
  //     const response = await apiHandler({
  //       method: "POST",
  //       route: "Superadmin/deletebymoduleid",
  //       payload: reqobj,
  //     });

  //     if (response.ResponseCode === "SUCCESS") {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //       setdelete(!deletes);
  //       prodcutDataListApi()
  //     } else {
  //       MySwal.fire({
  //         title: "Error!",
  //         text: "Something went wrong. Please try again.",
  //         icon: "error",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } catch (error) {
  //     MySwal.fire({
  //       title: "Error!",
  //       text: "An error occurred. Please try again later.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Business ID",
      accessorKey: "businessId",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Invoice ID",
      accessorKey: "stripeInvoiceId",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Subscription ID",
      accessorKey: "stripeSubscriptionId",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Customer ID",
      accessorKey: "stripeCustomerId",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Price ID",
      accessorKey: "stripePriceId",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Amount",
      accessorKey: "amount",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Currency",
      accessorKey: "currency",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Payment Method",
      accessorKey: "paymentMethod",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Payment Status",
      accessorKey: "paymentStatus",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Customer Email",
      accessorKey: "customerEmail",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Subscription Price ID",
      accessorKey: "subscriptionPriceId",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Subscription Template ID",
      accessorKey: "subscriptionTemplateId",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Plan Name",
      accessorKey: "planName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Subscription Name",
      accessorKey: "subscriptionName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) => <span>{dateFormat(row.original.createdAt)}</span>,
    },
    {
      header: "Modified At",
      accessorKey: "modifiedAt",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) => <span>{dateFormat(row.original.modifiedAt)}</span>,
    },
    {
      header: "Refund At",
      accessorKey: "refundAt",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) =>
        row.original.refundAt ? (
          <span>{dateFormat(row.original.refundAt)}</span>
        ) : (
          <span className="text-muted">—</span>
        ),
    },
    {
      header: "Decline Reason",
      accessorKey: "declineReason",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
        <span>
          {row.original.declineReason || <span className="text-muted">—</span>}
        </span>
      ),
    },
    // {
    //   header: "Deleted",
    //   accessorKey: "isDeleted",
    //   enableSorting: true,
    //   sortingFn: "numeric",
    //   Cell: ({ row }) => (
    //     <span
    //       className={
    //         row.original.isDeleted === 1
    //           ? "badge bg-danger"
    //           : "badge bg-success"
    //       }
    //     >
    //       {row.original.isDeleted === 1 ? "Deleted" : "Active"}
    //     </span>
    //   ),
    // },
  ];

  // const route = all_routes;

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/businessTransactionList?businessId=${
        user_data?.businessId || 0
      }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
      setLoading(false);
    } else {
      console.log(response, "data");
      setLoading(false);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  const exportData = productlist;

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
          />
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={productlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessTransaction;
